import TranslationsStore from './TranslationsStore';

class ErrorStore {
  static getError(errorName) {
    return TranslationsStore.getErrorTranslation()[errorName];
  }
}

export default ErrorStore;
